function getAutoClose(autoClose, toast) {
  if (typeof toast.autoClose === "number") {
    return toast.autoClose;
  }
  if (toast.autoClose === false || autoClose === false) {
    return false;
  }
  return autoClose;
}

export { getAutoClose };
//# sourceMappingURL=getAutoClose.mjs.map
